// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  scroll-behavior: smooth;
}

html,
body {
  position: relative;
}

*,
:after,
:before {
  box-sizing: inherit;
}

body.js-screenshot-mode * {
  transition: none !important;
}

/*
    At the moment of dynamic loading of the charts from @gravity-ui/chartkit, the main styles come to the runtime
    from @gravity-ui/uikit, which override font-family, where the basic font is 'Helvetica Neue'
    https://github.com/gravity-ui/uikit/blob/main/styles/typography.scss#L2
*/
body.g-root {
  --g-font-family-sans: "YS Text", "Helvetica Neue", "Arial", "Helvetica", sans-serif;
  --gn-top-alert-height: 0px;
  overscroll-behavior: none;
  scrollbar-width: var(--g-scrollbar-width);
  scrollbar-color: var(--g-color-scroll-handle) var(--g-color-scroll-track);
}
body.g-root::-webkit-scrollbar,
body.g-root *::-webkit-scrollbar {
  width: var(--g-scrollbar-width);
  height: var(--g-scrollbar-width);
  background: var(--g-color-scroll-track);
}
body.g-root::-webkit-scrollbar-track,
body.g-root *::-webkit-scrollbar-track {
  background: var(--g-color-scroll-track);
}
body.g-root::-webkit-scrollbar-corner,
body.g-root *::-webkit-scrollbar-corner {
  background: var(--g-color-scroll-corner);
}
body.g-root::-webkit-scrollbar-thumb,
body.g-root *::-webkit-scrollbar-thumb {
  background: var(--g-color-scroll-handle);
}
body.g-root::-webkit-scrollbar-thumb:hover,
body.g-root *::-webkit-scrollbar-thumb:hover {
  background: var(--g-color-scroll-handle-hover);
}

body.dl-iframe,
body.g-root_mobile {
  overscroll-behavior: auto;
}

.g-help-mark {
  margin-top: auto;
  margin-bottom: auto;
  flex-shrink: 0;
}

.g-help-mark__popover {
  max-width: var(--dl-help-mark-popover-max-width, 300px);
}`, "",{"version":3,"sources":["webpack://./src/ui/styles/base.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;;;EAGI,YAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,uBAAA;AADJ;;AAIA;;EAGI,kBAAA;AAFJ;;AAKA;;;EAGI,mBAAA;AAFJ;;AAKA;EACI,2BAAA;AAFJ;;AAKA;;;;CAAA;AAMA;EACI,mFAAA;EACA,0BAAA;EAEA,yBAAA;EAEA,yCAAA;EACA,yEAAA;AALJ;AC6SI;;EAEI,+BAAA;EACA,gCAAA;EACA,uCAAA;AD3SR;AC8SI;;EAEI,uCAAA;AD5SR;AC+SI;;EAEI,wCAAA;AD7SR;ACgTI;;EAEI,wCAAA;AD9SR;ACiTI;;EAEI,8CAAA;AD/SR;;AAXA;;EAEI,yBAAA;AAcJ;;AAXA;EACI,gBAAA;EACA,mBAAA;EACA,cAAA;AAcJ;;AAXA;EACI,uDAAA;AAcJ","sourcesContent":["html,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  scroll-behavior: smooth;\n}\n\nhtml,\nbody {\n  position: relative;\n}\n\n*,\n:after,\n:before {\n  box-sizing: inherit;\n}\n\nbody.js-screenshot-mode * {\n  transition: none !important;\n}\n\n/*\n    At the moment of dynamic loading of the charts from @gravity-ui/chartkit, the main styles come to the runtime\n    from @gravity-ui/uikit, which override font-family, where the basic font is 'Helvetica Neue'\n    https://github.com/gravity-ui/uikit/blob/main/styles/typography.scss#L2\n*/\nbody.g-root {\n  --g-font-family-sans: \"YS Text\", \"Helvetica Neue\", \"Arial\", \"Helvetica\", sans-serif;\n  --gn-top-alert-height: 0px;\n  overscroll-behavior: none;\n  scrollbar-width: var(--g-scrollbar-width);\n  scrollbar-color: var(--g-color-scroll-handle) var(--g-color-scroll-track);\n}\nbody.g-root::-webkit-scrollbar,\nbody.g-root *::-webkit-scrollbar {\n  width: var(--g-scrollbar-width);\n  height: var(--g-scrollbar-width);\n  background: var(--g-color-scroll-track);\n}\nbody.g-root::-webkit-scrollbar-track,\nbody.g-root *::-webkit-scrollbar-track {\n  background: var(--g-color-scroll-track);\n}\nbody.g-root::-webkit-scrollbar-corner,\nbody.g-root *::-webkit-scrollbar-corner {\n  background: var(--g-color-scroll-corner);\n}\nbody.g-root::-webkit-scrollbar-thumb,\nbody.g-root *::-webkit-scrollbar-thumb {\n  background: var(--g-color-scroll-handle);\n}\nbody.g-root::-webkit-scrollbar-thumb:hover,\nbody.g-root *::-webkit-scrollbar-thumb:hover {\n  background: var(--g-color-scroll-handle-hover);\n}\n\nbody.dl-iframe,\nbody.g-root_mobile {\n  overscroll-behavior: auto;\n}\n\n.g-help-mark {\n  margin-top: auto;\n  margin-bottom: auto;\n  flex-shrink: 0;\n}\n\n.g-help-mark__popover {\n  max-width: var(--dl-help-mark-popover-max-width, 300px);\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
